/* LBTM: align PDP award-badge overlays to the photo's painted area.
   With media_fit:contain the <img> letterboxes inside its slide, so a fixed
   top-left offset can land in the whitespace. Compute the contain-fit box and
   anchor the badge stack 12px inside it. CSS top/left:12px stays as fallback. */
(function () {
  var INSET = 12;
  function place() {
    document.querySelectorAll('.lbtm-img-badges').forEach(function (b) {
      var holder = b.closest('li') || b.parentElement;
      var img = holder && holder.querySelector('img:not(.lbtm-img-badge__img)');
      if (!img || !img.naturalWidth) return;
      var hr = holder.getBoundingClientRect();
      var r = img.getBoundingClientRect();
      if (!r.width || !hr.width) return;
      var s = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
      var pw = img.naturalWidth * s;
      var ph = img.naturalHeight * s;
      b.style.left = (r.left - hr.left + (r.width - pw) / 2 + INSET) + 'px';
      b.style.top = (r.top - hr.top + (r.height - ph) / 2 + INSET) + 'px';
    });
  }
  var t;
  function queue() { clearTimeout(t); t = setTimeout(place, 60); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queue);
  } else { queue(); }
  window.addEventListener('load', queue);
  window.addEventListener('resize', queue);
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') queue();
  }, true);
  if (window.ResizeObserver) {
    var seen = false;
    var ro = new ResizeObserver(queue);
    var arm = function () {
      document.querySelectorAll('.lbtm-img-badges').forEach(function (b) {
        var holder = b.closest('li') || b.parentElement;
        if (holder) { ro.observe(holder); seen = true; }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  }
})();
